<template>
	<div>
		<kefuright></kefuright>
		<home-swiper> </home-swiper>
		<div class="jisubox">
			<div class="banxin">
				<Con></Con>
			</div>
		</div>
		<div class="animate__animated animate__fadeInUp">
			<!-- 技术需求对接 -->
			<div class="quanbg ">
				<div class="pt60">
					<div class="gongtop">
						<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
						<div class="zhengbai">技术需求对接</div>
						<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
					</div>
					<div class="peotitle">
						解决企业获取外部创新资源问题，交易前、交易中、交易后全链条服务
					</div>
				</div>
			</div>

			<div class="jingbox">
				<div class="banxin">
					<div class="jingbai">
						<div class="wintop">
							<div class="wline"></div>
							<img src="../../../assets/img/images/wina_03.png" class="winpic" alt="" />
							<div class="wintitle">为供需双方提供便携技术对接平台</div>
							<img src="../../../assets/img/images/winb_03.png" class="winpic" alt="" />
							<div class="wline"></div>
						</div>
						<img src="../../../assets/img/images/yier_03.png" class="wenpic" alt="" />
						<div class="zhuboxa">
							<div class="zhuce" @click="goTohall">进入专题页面</div>
							<div class="zhuceact" @click="goToneed">需求大厅</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 综合服务导航 -->
		<div class="ruanbox">
			<div class="banxin">
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">综合服务导航</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="rennei">
					<div class="renleft">
						<div class="renli" @click="goToone">
							<img src="../../../assets/img/images/ha_03.png" class="renpic" alt="" />
							<img src="../../../assets/img/images/haa_03.png" class="renpica" alt="" />
							<div class="rencen">
								<div class="centitle">
									政策应用
								</div>
								<div class="centxt" >
									政策精准查询
								</div>
							</div>
							<img src="../../../assets/img/images/hf_03.png" class="renrr" alt="" />
							<img src="../../../assets/img/images/hfa_03.png" class="renact" alt="" />
						</div>
						<div class="renli">
							<img src="../../../assets/img/images/hb_03.png" class="renpic" alt="" />
							<img src="../../../assets/img/images/hba_03.png" class="renpica" alt="" />
							<div class="rencen">
								<div class="centitle" @click="goTotwo">
									技术升级
								</div>
								<div class="centxt">
									<span @click="goTotwo">需求发布</span> <span @click="goTothree">需求大厅</span>
								</div>
							</div>
							<img src="../../../assets/img/images/hf_03.png" class="renrr" alt="" />
							<img src="../../../assets/img/images/hfa_03.png" class="renact" alt="" />
						</div>
						<div class="renli">
							<img src="../../../assets/img/images/hc_03.png" class="renpic" alt="" />
							<img src="../../../assets/img/images/hca_03.png" class="renpica" alt="" />
							<div class="rencen">
								<div class="centitle" @click="goTofore">
									成果服务
								</div>
								<div class="centxt">
									<span @click="goTofore">成果查询</span> <span @click="goTofive">成果发布</span>
								</div>
							</div>
							<img src="../../../assets/img/images/hf_03.png" class="renrr" alt="" />
							<img src="../../../assets/img/images/hfa_03.png" class="renact" alt="" />
						</div>
						<div class="renli" @click="goTosix">
							<img src="../../../assets/img/images/hd_03.png" class="renpic" alt="" />
							<img src="../../../assets/img/images/hda_03.png" class="renpica" alt="" />
							<div class="rencen">
								<div class="centitle">
									知识服务
								</div>
								<div class="centxt" >
									专利查询
								</div>
							</div>
							<img src="../../../assets/img/images/hf_03.png" class="renrr" alt="" />
							<img src="../../../assets/img/images/hfa_03.png" class="renact" alt="" />
						</div>
						<div class="renli">
							<img src="../../../assets/img/images/he_03.png" class="renpic" alt="" />
							<img src="../../../assets/img/images/hea_03.png" class="renpica" alt="" />
							<div class="rencen">
								<div class="centitle" @click="goToseven">
									人才服务
								</div>
								<div class="centxt">
									<span @click="goToseven">专家智库</span> <span @click="goToenight">职位发布</span>
								</div>
							</div>
							<img src="../../../assets/img/images/hf_03.png" class="renrr" alt="" />
							<img src="../../../assets/img/images/hfa_03.png" class="renact" alt="" />
						</div>
					</div>
					<!-- <img src="../../../assets/img/images/dpa.png" class="renda" alt="" /> -->
					<div class="renda">
						<el-carousel height="640px" :interval="5000" arrow="always">
							<el-carousel-item>
								<img src="../../../assets/img/images/dpa.png" class="renda" alt="" />
							</el-carousel-item>
							<el-carousel-item>
								<img src="../../../assets/img/images/qyy.jpg" class="renda" alt="" />
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>
		</div>
		<!-- 综合服务-技术转移 -->
		<div class="zongbg">
			<div class="pt60">
				<div class="gongtop">
					<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
					<div class="zhengbai">综合服务-技术转移</div>
					<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
				</div>
				<div class="peotitle">
					解决企业获取外部创新资源问题，交易前、交易中、交易后全链条服务
				</div>
			</div>
		</div>
		<div class="jingbox">
			<div class="banxin">
				<div class="jingbai">
					<el-carousel height="460px" arrow="always" loop="true" :autoplay="false">
						<el-carousel-item class="el-car-item" v-for="(list, index) in dataList" :key="index">
							<div v-for="(imgList,index2) in list" :key="index2" class="caili" @click="xqaa(imgList.id)">
								<div class="caititle oneline">
									{{imgList.title}}
								</div>
								<img :src="urlImg + imgList.img" class="caipic"  alt="" />
								<div class="caitxt twolines" v-html="imgList.describe">
								</div>
								<!-- <div class="cailan" @click="xqaa(imgList.id)">
									了解更多 >
								</div> -->
							</div>
						</el-carousel-item>
					</el-carousel>
					<div class="zhuboxa" style="padding-top: 20px;">
						<div class="zhuce"  @click="toDocking">进入专题页面</div>
					</div>

				</div>
			</div>
		</div>

		<!-- 综合服务-知识产权 -->
		<div class="zcbg">
			<div class="pt60">
				<div class="gongtop">
					<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
					<div class="zhengbai">综合服务-知识产权</div>
					<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
				</div>
				<div class="peotitle">
					集专利、商标、软著等的技术成果综合为一体的全方位的服务活动，主要进行转让、登记、咨询等。
				</div>
			</div>
		</div>
		<div class="jingbox">
			<div class="banxin">
				<div class="jingbai">
					<div class="paibox">
						<div class="paili" v-for="(ie, index) in fwList" :key="index" @click="xq(ie.id)">
							<div class="paititle oneline">
								{{ ie.title }}
							</div>
							<div class="paitxt twolines" v-html="ie.describe"></div>
							<div class="libox">
								<div class="lileft">
									<div class="lilan">立即购买</div>
									<div class="lizi">立即咨询</div>
								</div>
								<div class="limoney">{{ ie.cost }}元</div>
							</div>
						</div>
					</div>
					<div class="zhuboxa" style="padding-top: 10px;">
						<div class="zhuce" @click="to_zt">进入专题页面</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 政策展示 -->
		<div class="cebox">
			<div class="banxin">
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">政策展示</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="cenei">
					<div class="celeft">
						<div class="cetitle">
							政策速递
						</div>
						<div class="cetxt">
							利用大数据产业分析，智能快速的解决企业的产业政策匹配与运用问题。
						</div>
						<div class="cejin" @click="gotozt">
							进入专题页面
						</div>
					</div>
					<div class="cecen">
						<div class="cecentop">
							<div class="ctleft">
								<img src="../../../assets/img/images/zhu_14.png" class="zhupic" alt="" />
								<div class="zctxt">
									政策大数据可视化
								</div>
							</div>
							<div class="jibie">
								<div class="jibieli"   v-for="city in cityList" :key="city.index">
									<div class="bietitle">
										{{ city.num }}
									</div>
									<div class="bietxt">
										{{ city.name }}
									</div>
								</div>
								
							</div>
						</div>
						<city style="margin-top: -10px"></city>
					</div>
					<div class="ceright">
						<div class="ceding">政策汇集</div>
						<div class="cesee" @click="more()">
							查看更多>
						</div>
						<div class="guobox" v-for="(c ,index) in newList" :key="c.index">
							<img src="../../../assets/img/images/xinb_03.png" v-if="index < 3" class="guopic" alt="" />
							<img src="../../../assets/img/images/xina_03.png" v-else class="guopic" alt="" />
							<div class="guoright">
								<div class="guotitle oneline">
									{{c.title}}
								</div>
								<div class="guotime">
									{{ c.year }}{{ c.created_at  | formatDate}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 综合服务-科技金融 -->
		<div class="zcbg">
			<div class="pt60">
				<div class="gongtop">
					<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
					<div class="zhengbai">综合服务-科技金融</div>
					<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
				</div>
				<div class="peotitle">
					通过创新财政科技投入，引导创新金融产品，搭建服务平台，实现科技与金融的有机结合。
				</div>
			</div>
		</div>
		<div class="jingbox">
			<div class="banxin">
				<div class="jingbai">
					<div class="paibox">
						<div class="paili" v-for="(ie, index) in paiList" :key="index" @click="xq(ie.id)">
							<div class="paititle oneline">
								{{ ie.title }}
							</div>
							<div class="paitxt twolines" v-html="ie.describe"></div>
							<div class="libox">
								<div class="lileft">
									<div class="lilan">立即购买</div>
									<div class="lizi">立即咨询</div>
								</div>
								<div class="limoney">{{ ie.cost }}元</div>
							</div>
						</div>
					</div>
					<div class="zhuboxa" style="padding-top: 10px;">
						<div class="zhuce" @click="goto_zt">进入专题页面</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 综合服务-项目生命周期咨询 -->
		<div class="zongbg">
			<div class="pt60">
				<div class="gongtop">
					<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
					<div class="zhengbai">综合服务-项目生命周期咨询</div>
					<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
				</div>
				<div class="peotitle">
					提供对工程项目前期研究和决策的全生命周期的设计和规划的多方面的咨询服务
				</div>
			</div>
		</div>
		<div class="jingbox">
			<div class="banxin">
				<div class="jingbai">
					<el-carousel height="460px" arrow="always" loop="true" :autoplay="false">
						<el-carousel-item class="el-car-item" v-for="(lista, index) in swiperList" :key="index">
							<div v-for="(imgList,index) in lista" :key="index" class="caili" @click="xqbb(imgList.id)">
								<div class="caititle oneline">
									{{imgList.title}}
								</div>
								<img :src="urlImg + imgList.img" class="caipic"  alt="" />
								<div class="caitxt twolines" v-html="imgList.describe"></div>
								<!-- <div class="cailan" @click="xqbb(imgList.id)">
									了解更多 >
								</div> -->
							</div>
						</el-carousel-item>
					</el-carousel>
					<div class="zhuboxa" style="padding-top: 20px;">
						<div class="zhuce"  @click="to_zx">进入专题页面</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 综合服务-人才猎寻 -->
		<div class="liebg">
			<div class="pt60 banxin">
				<div class="gongtop">
					<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
					<div class="zhengbai">综合服务-人才猎寻</div>
					<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
				</div>
				<div class="peotitle">
					招纳社会各行业领先人才，聚焦行业最新前沿
				</div>

				<div class="sanlun">
					
					<div v-for="(imgList,index) in expertList" :key="index" class="caili" @click="to_expert(imgList.id)">
						<div class="caititle">
							研究生及以上
						</div>
						<img class="caipic" :src="urlImg + imgList.img" />
						<div class="caitxt twolines">
							{{imgList.name}}
						</div>
						<div class="bailine"></div>
						<div class="jianjie twolines">
							个人简介：{{imgList.resume}}
						</div>
					</div>
					<div v-for="(imgList,index) in expertLista" :key="index" class="caili" @click="to_expert(imgList.id)">
						<div class="caititle oneact" >
							本科
						</div>
						<img class="caipic" :src="urlImg + imgList.img" />
						<div class="caitxt twolines">
							{{imgList.name}}
						</div>
						<div class="bailine"></div>
						<div class="jianjie twolines">
							个人简介：{{imgList.resume}}
						</div>
					</div>
					<div v-for="(imgList,index) in expertListb" :key="index" class="caili" @click="to_expert(imgList.id)">
						<div class="caititle twoact ">
							其他
						</div>
						<img class="caipic" :src="urlImg + imgList.img" />
						<div class="caitxt twolines">
							{{imgList.name}}
						</div>
						<div class="bailine"></div>
						<div class="jianjie twolines">
							个人简介：{{imgList.resume}}
						</div>
					</div>
				</div>
				<div class="zhuboxa">
					<div class="zhuce" @click="to_rc">进入专题页面</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import kefuright from '../../../components/common/kefu';
	import $ from "jquery";
	import HomeSwiper from "../../../components/common/Swiper";
	import FromList from "../../../common/input";
	import Con from "./kcon";
	import city from "../../qiyeyun/base/city";
	import { urlImg } from "@/common/js/url";
	import {
		Wisdom,
		achievementsLists,
		Sdisplay,
		Data,
		DataZC,
		Expert
	} from "../../../common/js/api";
	import { ServerKnowledge } from "@/common/js/api";
	import {policy_system} from "../../common/js/api";
	import {
		zhi
	} from "../../common/js/api";
	import {
		formatDate
	} from "../../../common/js/times"; //时间

	export default {
		name: "zhichanyunForm",
		components: {
			FromList,
			HomeSwiper,
			Con,
			city,
			kefuright,
			NumberRoller: () => import("@/common/number-roller.vue"),
		},
		data() {
			return {
				// 地图
				cityList: [],
				// 知识产权
				fwList: [],
				// 轮播1
				listQuery: {
				        limit: 9,
				        page: 1,
				      },
				dataList: [],
				// 政策汇集
				newList:[],
				paiList:[],
				// 综合服务-项目生命周期咨询
				swiperList: [{
						img: require('../../../assets/img/images/caia_03.png'),
						title: '选址论证',
						txt: '选址论证报告主要是针对项目在建筑前对地址的论证和决策，以确定项目所在...'
					},
					{
						img: require('../../../assets/img/images/caia_03.png'),
						title: '交通影响评价',
						txt: '政府采购项目验收是指在政府采购合同执行过程中或执行完毕，采购人对政府采购合同执行...'
					},
					{
						img: require('../../../assets/img/images/caia_03.png'),
						title: '重大投资项目社会稳定风险评估',
						txt: '政府采购项目验收是指在政府采购合同执行过程中或执行完毕，采购人对政府采购合同执行...'
					},
					{
						img: require('../../../assets/img/images/caia_03.png'),
						title: '标题',
						txt: '政府采购项目验收是指在政府采购合同执行过程中或执行完毕，采购人对政府采购合同执行...'
					},
					{
						img: require('../../../assets/img/images/caia_03.png'),
						title: '标题',
						txt: '政府采购项目验收是指在政府采购合同执行过程中或执行完毕，采购人对政府采购合同执行...'
					},
					{
						img: require('../../../assets/img/images/caia_03.png'),
						title: '标题',
						txt: '政府采购项目验收是指在政府采购合同执行过程中或执行完毕，采购人对政府采购合同执行...'
					},

				],
				// 综合服务-人才猎寻
				expertList:[],
				expertLista:[],
				expertListb:[]
			};
		},
		created() {
			this.urlImg = urlImg();
			this.getSdisplay();
			this.getDataZC()
			this.getLibrary()
			
			this.ServerKnowledge()
			this.ServerKnowledgea()
			this.getExpert();
		},
		mounted() {
			// this.getDataSource()
			// this.getswiper()
			// this.getsanswiper()
		},
		methods: {
			 getExpert() {
			      Expert()
			        .then((res) => {
			          console.log(res,'ddddddddddddddddddddd');
			          this.expertList = res.data.one.slice(0, 2);
			          this.expertLista = res.data.two.slice(0, 2);
			          this.expertListb = res.data.there.slice(0, 2);
			        })
			        .catch(() => {});
			    },
			 // 项目生命周期咨询 —————— 进入专题页面
			    to_zx() {
			      this.$router.push({
			        path: "/special",
			        query: {
			          s: "zqzx",
			        },
			      });
			    },
				// 前往技术转移
				    toDocking() {
				      this.$router.push({
				         path: "/special",
				        query: {
				          s: "jszy",
				        },
				      });
				    },
			 // 政策大数据
			    getDataZC() {
			      DataZC()
			        .then((res) => {
			          this.cityList = res.data[0].nums;
			        })
			        .catch(() => {});
			    },
			// 知识产权
			getSdisplay() {
				
				Sdisplay()
					.then((res) => {
						
						this.fwList = res.data.three.slice(0, 6);
						this.paiList = res.data.one.slice(0, 6);
					})
					.catch(() => {});
			},
			// 进入专题页面
			goto_zt() {
				this.$router.push({
					path: '/special',
					query: {
						s: 'kjjr'
					}
				});
			},
			 // 人才猎寻 —————— 进入专题页面
			    to_rc() {
			      this.$router.push({
			        // path: "/special",
			        // query: {
			        //   s: "rclx",
			        // },
			        path: "/scientist",
			      });
			    },
			// 进入详情页
			xq(id) {
				this.$router.push({
					path: "/s_xq",
					query: {
						id: id,
					},
				});
			},


			// 政策应用
			goToone() {
				this.$router.push({
					path: '/member5/test5-1'
				})
			},
			// 需求发布
			goTotwo() {
				this.$router.push({
					path: '/need'
				})
			},
			// 需求大厅
			goTothree() {
				this.$router.push({
					path: '/hall'
				})
			},
			
			// 成果查询
			goTofore() {
				this.$router.push({
					path: '/member3/test3-1'
				})
			},
			// 成果发布
			goTofive() {
				this.$router.push({
					path: '/sucessresult'
				})
			},
			// 专利查询
			goTosix() {
				this.$router.push({
					path: '/Patent'
				})
			},
			// 进入专题知识产权页面
			to_zt() {
			  this.$router.push({
				path: "/special",
				query: {
				  s: "zscq",
				},
			  });
			},
			// 政策应用 ——————进入专题页面
			gotozt() {
			  this.$router.push({
				path: "/special",
				query: {
				  s: "zcyy",
				},
			  });
			},
			// 最新发布政策
			getLibrary() {
			  policy_system({
				page: 1,
				limits: 5,
				new: 1, 
			  })
				.then((res) => {
				  this.newList = res.data.data;
				  for (var i = 0; i < this.newList.length; i++) {
					this.newList[i].details = this.newList[i].details.replace(
					  /<\/?(img)[^>]*>/gi,
					  ""
					);
				  }
				})
				.catch(() => {});
			},
			// 查看更多政策应用
			more() {
			  this.$router.push({
				path: "/member5",
			  });
			},
			// 专家智库
			goToseven() {
				this.$router.push({
					path: '/member7/test7-1'
				})
			},
			// 人才发布
			goToenight() {
				this.$router.push({
					path: '/position'
				})
			},
			// 需求大厅
			goTohall() {
				this.$router.push({
					path: '/hall'
				})
			},
			// 专题页面
			goToneed() {
				this.$router.push({
					path: '/need'
				})
			},



			// 列表1
			ServerKnowledge() {
			  ServerKnowledge({
				type: 114,
				page: this.listQuery.page,
				limits: this.listQuery.limit,
			  })
				.then((res) => {
					
				  this.dataList = res.data.data;
				  console.log('=================',this.dataList)
				  this.getDataSource()
				})
				.catch(() => {});
				
			},
			// 进入详情页
			xqaa(id) {
			  this.$router.push({
				path: "/s_xq",
				query: {
				  id: id,
				},
			  });
			},
			getDataSource() {
				let newDataList = []
				let current = 0
				if (this.dataList && this.dataList.length > 0) {
					for (let i = 0; i <= this.dataList.length - 1; i++) {
						if (i % 3 !== 0 || i === 0) {
							if (!newDataList[current]) {
								newDataList.push([this.dataList[i]])
							} else {
								newDataList[current].push(this.dataList[i])
							}
						} else {
							current++
							newDataList.push([this.dataList[i]])
						}
					}
				}
				this.dataList = [...newDataList]
			},
			// 前往专家详情
			    to_expert(id) {
			      this.$router.push({
			        path: "/expert",
			        query: {
			          id: id,
			        },
			      });
			    },
			// 列表2
			ServerKnowledgea() {
			  ServerKnowledge({
				type: 123,
				page: this.listQuery.page,
				limits: this.listQuery.limit,
			  })
				.then((res) => {
				  this.swiperList = res.data.data;
				  this.getswiper()
				})
				.catch(() => {});
			},
			xqbb(id) {
			  this.$router.push({
				path: "/s_xq",
				query: {
				  id: id,
				},
			  });
			},
			getswiper() {
				let DataList = []
				let current = 0
				if (this.swiperList && this.swiperList.length > 0) {
					for (let i = 0; i <= this.swiperList.length - 1; i++) {
						if (i % 3 !== 0 || i === 0) {
							if (!DataList[current]) {
								DataList.push([this.swiperList[i]])
							} else {
								DataList[current].push(this.swiperList[i])
							}
						} else {
							current++
							DataList.push([this.swiperList[i]])
						}
					}
				}
				this.swiperList = [...DataList]
			},

			getsanswiper() {
				let sanDataList = []
				let current = 0
				if (this.sanList && this.sanList.length > 0) {
					for (let i = 0; i <= this.sanList.length - 1; i++) {
						if (i % 6 !== 0 || i === 0) {
							if (!sanDataList[current]) {
								sanDataList.push([this.sanList[i]])
							} else {
								sanDataList[current].push(this.sanList[i])
							}
						} else {
							current++
							sanDataList.push([this.sanList[i]])
						}
					}
				}
				this.sanList = [...sanDataList]
			},
		},
		computed: {
			optionHover() {
				return {
					step: 0.6, //速度，值越大，速度越快
					hoverStop: true, //鼠标悬停效果，false为关闭该效果
					// singleHeight: 26, //单行停顿
					// waitTime: 2500 //单行停顿的时间
					limitMoveNum: 1 // 开始无缝滚动的数据量
				};
			}
		}
	};
</script>

<style scoped lang="less">
	.el-car-item {
		width: 100%;
		display: flex;
	}

	.banxin {
		width: 1400px;
		margin: 0 auto;
	}

	.pt60 {
		padding-top: 60px;
	}

	.qiyetop {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 60px;

		.zhengpic {
			width: 118px;
			height: 27px;
			flex-shrink: 0;
		}

		.zhengtitle {
			font-size: 36px;
			color: #222222;
			font-weight: bold;
			padding: 0 35px;
		}

		.zhengbai {
			font-size: 36px;
			color: #ffffff;
			font-weight: bold;
			padding: 0 35px;
		}
	}

	.gongtop {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 25px;

		.zhengpic {
			width: 118px;
			height: 27px;
			flex-shrink: 0;
		}

		.zhengtitle {
			font-size: 36px;
			color: #222222;
			font-weight: bold;
			padding: 0 35px;
		}

		.zhengbai {
			font-size: 36px;
			color: #ffffff;
			font-weight: bold;
			padding: 0 35px;
		}
	}

	.jisubox {
		padding-bottom: 60px;
		display: flex;
		background-color: #f6f6f6;

	}

	.quanbg {
		width: 100%;
		height: 380px;
		background: url('../../../assets/img/images/quanbg_06.png') no-repeat center;
		background-size: 100% 380px;

		.peotitle {
			font-size: 16px;
			color: #ffffff;
			text-align: center;
		}
	}

	.zongbg {
		width: 100%;
		height: 380px;
		background: url('../../../assets/img/images/zongbg_09.png') no-repeat center;
		background-size: 100% 380px;

		.peotitle {
			font-size: 16px;
			color: #ffffff;
			text-align: center;
		}
	}

	.zcbg {
		width: 100%;
		height: 380px;
		background: url('../../../assets/img/images/rbg.png') no-repeat center;
		background-size: 100% 380px;

		.peotitle {
			font-size: 16px;
			color: #ffffff;
			text-align: center;
		}
	}

	/deep/.el-carousel__button {
		background-color: transparent;
		height: 5px !important;
		width: 20px !important;
		border-radius: 25px;
		background-color: #0289f4;
		opacity: 0.3;
	}

	/deep/.el-carousel__indicator.is-active button {
		background-color: #0289f4;
		height: 5px !important;
		width: 20px !important;
		border-radius: 25px;
	}

	/deep/.el-carousel__indicators--horizontal {
		bottom: 5px;
	}

	/deep/.el-carousel__arrow {
		background-color: transparent !important;
		right: 1px;
	}
	/deep/.el-carousel__arrow i{
		font-size: 40px;
		color: #aaaaaa;
		display: none !important;
	}
	/deep/.el-carousel__arrow--left {
		left: 0;
	}

	/deep/.el-carousel__arrow i:hover{
		color: #0289f4 !important;
	}
	

	.jingbox {
		display: flex;
		background-color: #f6f6f6;
		padding-bottom: 60px;

		.jingbai {
			padding: 30px 20px 40px;
			background-color: #ffffff;
			border-radius: 7px;
			margin-top: -210px;

			.caili {
				cursor: pointer;
				padding: 0 30px;
				width: 430px;
				height: 450px;
				background-color: #ffffff;
				box-shadow: 0 0 5px #dddddd;
				border: 1px solid #eeeeee;
				margin-right: 35px;
				transition: all 0.5s;
				flex-shrink: 0;
				.caititle {
					font-size: 24px;
					color: #222222;
					font-weight: bold;
					padding: 30px 0;
				}

				.caipic {
					width: 100%;
					height: 225px;
				}

				.caitxt {
					font-size: 14px;
					color: #888888;
					padding: 23px 0 0;
					margin-bottom: 56px;
					line-height: 28px;
				}

				.cailan {
					cursor: pointer;
					color: #0289f4;
					font-size: 16px;
				}
			}
			.caili:hover{
				background-color: #0289f4;
				.caititle{
					color: #ffffff;
				}
				.caitxt{
					color: #ffffff;
				}
			}
			.wintop {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 60px;
				margin-bottom: 30px;

				.wline {
					width: 383px;
					height: 1px;
					background-color: #dddddd;
				}

				.winpic {
					width: 22px;
					height: 23px;
					margin: 0 12px;
				}

				.wintitle {
					font-size: 30px;
					color: #333333;
					font-weight: bold;
					padding: 0 20px;
				}
			}

			.winpic {
				width: 100%;
				height: 525px;
			}

			
		}
		.zhuboxa {
			display: flex;
			align-items: center;
			justify-content: center;
		
			.zhuce {
				width: 205px;
				height: 40px;
				margin: 0 20px;
				cursor: pointer;
				background-color: #ff4200;
				border: 1px solid #ff4200;
				font-size: 18px;
				color: #ffffff;
				text-align: center;
				border-radius: 5px;
				line-height: 40px;
				transition: all 0.5s;
			}
			.zhuce:hover{
				transform: translateY(-10%);
			}
			.zhuceact {
				width: 205px;
				height: 40px;
				margin: 0 20px;
				cursor: pointer;
				border: 1px solid #ff4200;
				font-size: 18px;
				color: #ff4200;
				text-align: center;
				border-radius: 5px;
				line-height: 40px;
				transition: all 0.5s;
			}
			.zhuceact:hover{
				transform: translateY(-10%);
			}
		}
	}

	.ruanbox {
		background-color: #f6f6f6;
		padding-bottom: 60px;

		.rennei {
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			padding-bottom: 40px;

			.renleft {
				width: 330px;

				.renli {
					height: 128px;
					transition: all 0.5s;
					display: flex;
					align-items: center;
					padding: 0 15px 0 22px;
					cursor: pointer;
					border-radius: 5px;

					.renpic {
						width: 47px;
						height: 42px;
						flex-shrink: 0;
					}

					.renpica {
						display: none;
						width: 47px;
						height: 42px;
						flex-shrink: 0;
					}

					.rencen {
						flex-grow: 1;
						padding: 0 12px;

						.centitle {
							font-size: 22px;
							color: #888888;
							padding-bottom: 11px;
						}

						.centxt {
							font-size: 18px;
							color: #c4c4c4;

							span {
								font-size: 18px;
								color: #c4c4c4;
								padding-right: 5px;
							}
						}
					}

					.renrr {
						width: 32px;
						height: 32px;
						margin-top: 15px;
					}

					.renact {
						width: 32px;
						height: 32px;
						margin-top: 15px;
						display: none;
					}
				}

				.renli:hover {
					background-color: #0289f4;
					box-shadow: 0 0 18px #0289f4;

					.renpic {
						display: none;
					}

					.renpica {
						display: block;
					}

					.rencen {
						flex-grow: 1;
						padding: 0 12px;

						.centitle {
							color: #ffffff;
						}

						.centxt {
							color: #ffffff;
							span {
								color: #ffffff;
							}
						}
					}

					.renrr {
						display: none;
					}

					.renact {
						display: block;
					}
				}
			}

			.renda {
				width: 1050px;
				height: 640px;
				
				
				/deep/.el-carousel__indicator.is-active button {
					background-color: #ffffff;
					height: 5px !important;
					width: 20px !important;
					border-radius: 25px;
				}
			}
		}
	}

	.paibox {
		padding: 0 10px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.paili:nth-child(3n) {
			margin-right: 0;
		}

		.paili {
			width: 430px;
			height: 200px;
			box-shadow: 0 0 6px #dddddd;
			background-image: linear-gradient(#f8fcfd, #ffffff);
			margin: 0 25px 23px 0;
			padding: 0 20px;
			cursor: pointer;
			transition: all 0.5s;
			.paititle {
				font-size: 20px;
				color: #222222;
				font-weight: bold;
				padding: 22px 0 12px;
			}

			.paitxt {
				font-size: 16px;
				color: #adb0b9;
				line-height: 26px;
				margin-bottom: 38px;
			}

			.libox {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.lileft {
					display: flex;
					align-items: center;

					.lilan {
						width: 123px;
						height: 37px;
						background-color: #0289f4;
						text-align: center;
						line-height: 37px;
						font-size: 16px;
						color: #ffffff;
						cursor: pointer;
						margin-right: 10px;
						transition: all 0.5s;
					}
					// .lilan:hover{
					// 	background-color: #fdf4eb;
					// 	color: #ff7200;
					// }

					.lizi {
						width: 123px;
						height: 37px;
						background-color: #fdf4eb;
						text-align: center;
						line-height: 37px;
						font-size: 16px;
						color: #ff7200;
						cursor: pointer;
						margin-right: 10px;
						transition: all 0.5s;
					}
					// .lizi:hover{
					// 	background-color: #0289f4;
					// 	color: #ffffff;
					// }
				}

				.limoney {
					color: #ff0000;
					font-size: 18px;
				}
			}
		}
		.paili:hover{
			transform: translateY(-6%);
			.paititle {
				color: #0289f4;
			}
		}
	}

	.cebox {
		background-color: #f6f6f6;
		padding-bottom: 60px;

		.cenei {
			display: flex;
			align-items: flex-start;
			justify-content: space-between;

			.celeft {
				width: 300px;
				height: 500px;
				background: url('../../../assets/img/images/cebg_05.png') no-repeat center;
				background-size: 300px 500px;
				padding: 0 27px;
				border-radius: 8px;
				.cetitle {
					font-size: 28px;
					color: #ffffff;
					font-weight: bold;
					padding-bottom: 20px;
					padding-top: 36px;
				}

				.cetxt {
					font-size: 18px;
					color: #ffffff;
					line-height: 35px;
					padding-bottom: 26px;
				}

				.cejin {
					width: 138px;
					height: 34px;
					font-size: 16px;
					color: #ffffff;
					text-align: center;
					line-height: 34px;
					border: 1px solid #ffffff;
					cursor: pointer;
					transition: all 0.5s;
					border-radius: 5px;
				}
				.cejin:hover{
					transform: translateY(-10%);
					background-color: #ffffff;
					color: #0289f4;
				}
			}
			
			
			.cecen {
				width: 650px;
				height: 500px;
				background-color: #ffffff;
				flex-shrink: 0;

				.cecentop {
					display: flex;
					align-items: flex-start;
					padding: 25px 35px 0 20px;
					justify-content: space-between;

					.ctleft {
						display: flex;
						align-items: center;

						.zhupic {
							width: 24px;
							height: 20px;
						}

						.zctxt {
							font-size: 24px;
							color: #222222;
							padding-left: 7px;
						}
					}

					.jibie {
						width: 335px;
						height: 65px;
						border: 1px solid #e5e5e5;
						display: flex;
						align-items: center;

						.jibieli {
							width: 25%;
							text-align: center;

							.bietitle {
								font-size: 24px;
								color: #0289f4;
								font-weight: bold;
								padding-bottom: 5px;
								
							}

							

							.bietxt {
								font-size: 14px;
								color: #222222;
							}
						}
						.jibieli:nth-child(2n){
							.bietitle {
								color: #ff7200;
							}
						}
					}
				}
			}

			.ceright {
				width: 410px;
				height: 500px;
				padding: 0 20px;
				background-color: #ffffff;
				position: relative;

				.ceding {
					width: 170px;
					height: 45px;
					background: url('../../../assets/img/images/lanbg_11.png') no-repeat center;
					top: 20px;
					left: -14px;
					position: absolute;
					background-size: cover;
					text-align: center;
					line-height: 40px;
					color: #ffffff;
					font-size: 22px;
					font-weight: bold;
				}

				.cesee {
					font-size: 16px;
					color: #888888;
					text-align: right;
					padding: 35px 0 30px;
					cursor: pointer;
				}

				.guobox {
					display: flex;
					align-items: flex-start;
					padding-bottom: 31px;
					cursor: pointer;

					.guopic {
						width: 40px;
						height: 35px;
						flex-shrink: 0;
					}

					.guoright {
						padding-left: 10px;
						flex-shrink: 0;
						padding-top: 8px;

						.guotitle {
							font-size: 18px;
							color: #000000;
							padding-bottom: 14px;
							max-width: 320px;
						}
						.guotitle:hover{
							color: #0289f4;
						}
						.guotime {
							font-size: 14px;
							color: #888888;
						}
					}
				}
			}
		}
	}

	.liebg {
		width: 100%;
		height: 650px;
		background: url('../../../assets/img/images/wobg_02.png') no-repeat center;
		background-size: 100% 650px;

		.peotitle {
			font-size: 16px;
			color: #ffffff;
			text-align: center;
		}

		.sanlun {
			margin-top: 37px;
			height: 330px;
			display: flex;
			align-items: center;
			.caili:first-child{
				border-left: 1px solid #ffffff;
			}
			.caili {
				position: relative;
				width: 235px;
				height: 330px;
				background-color: rgba(0, 0, 0, 0.2);
				border: 1px solid #ffffff;
				border-left: none;
				text-align: center;
				transition: all 0.45s;
				.caititle {
					width: 130px;
					height: 40px;
					background-color: #ff7200;
					font-size: 18px;
					color: #ffffff;
					position: absolute;
					left: 0;
					top: 15px;
					line-height: 40px;
					border-radius: 0 30px 30px 0;
				}

				.oneact {
					background-color: #0289f4;
				}

				.twoact {
					background-color: #e60012;
				}

				.caipic {
					margin: 80px auto 15px;
					width: 90px;
					height: 90px;
					border-radius: 50%;
				}

				.caitxt {
					font-size: 24px;
					color: #ffffff;
					padding-bottom: 15px;
				}

				.bailine {
					width: 50px;
					height: 1px;
					background-color: #ffffff;
					margin: 0 auto;
				}

				.jianjie {
					font-size: 16px;
					color: #888888;
					line-height: 25px;
					padding: 25px 15px 0;
				}
			}
			.caili:hover{
				height: 370px;
				background-color: #0289f4;
				.jianjie{
					color: #ffffff;
				}
			}
		}
		.zhuboxa {
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 40px;
		
			.zhuce {
				width: 205px;
				height: 40px;
				margin: 0 20px;
				cursor: pointer;
				background-color: #ffffff;
				border: 1px solid #ffffff;
				font-size: 18px;
				color: #333333;
				text-align: center;
				border-radius: 5px;
				line-height: 40px;
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.banxin{
			width: 98%;
			margin: 0 auto;
			display: block;
		}
		.ruanbox .rennei{
			flex-wrap: wrap;
			overflow: hidden;
		}
		.cebox .cenei{
			flex-wrap: wrap;
			overflow: hidden;
		}
		
		.cebox .cenei .celeft .cetitle{
			font-size: 2rem;
		}
		.cebox .cenei .celeft .cetxt{
			width: 100%;
			font-size: 1.5rem;
			line-height: 2.5rem;
		}
		.cebox .cenei .celeft .cejin{
			width: 10rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.4rem;
		}
		.cebox .cenei .ceright{
			width: 100%;
			height: auto;
		}
		.cebox .cenei .ceright .guobox .guoright .guotitle{
			max-width: 64%;
			font-size: 1.8rem;
		}
		.cebox .cenei .ceright .guobox .guopic{
			width: 3rem;
			height: 2.7rem;
		}
		.cebox .cenei .ceright .guobox .guoright .guotime{
			font-size: 1.4rem;
		}
		.cebox .cenei .ceright .ceding[data-v-5af70f0f]{
			width: 10rem;
			height: 3.5rem;
			background-size: 10rem 3.5rem;
			line-height: 3rem;
			font-size: 1.4rem;
		}
		.cebox .cenei .ceright .cesee{
			font-size: 1.4rem;
		}
		.gongtop .zhengbai{
			font-size: 2.3rem;
		}
		.quanbg{
			height: 25rem;
			background-size: 100% 25rem;
		}
		.quanbg .peotitle{
			font-size: 1.6rem;
			padding: 0 2rem;
			line-height: 2.2rem;
		}
		.jingbox .jingbai .wintop .wline{
			width: 1rem;
		}
		.jingbox .jingbai .wintop .wintitle{
			font-size: 2.2rem;
		}
		.jingbox .jingbai .zhuboxa .zhuce{
			width: 12rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.6rem;
		}
		.jingbox .jingbai .zhuboxa .zhuceact{
			width: 12rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.6rem;
		}
		.qiyetop .zhengtitle{
			font-size: 3rem;
		}
		.ruanbox .rennei .renleft{
			width: 100%;
			display: flex;
			align-items: flex-start;
			flex-wrap: wrap;
		}
		.ruanbox .rennei .renleft .renli{
			width: 50%; 
		}
		.zongbg .peotitle{
			font-size: 1.6rem;
			padding: 0 3rem;
			line-height: 2.2rem;
		}
		.zcbg .peotitle{
			font-size: 1.6rem;
			padding: 0 3rem;
			line-height: 2.2rem;
		}
		.zcbg{
			height: 23rem;
			background-size: 100% 23rem;
		}
		.zongbg{
			height: 23rem;
			background-size: 100% 23rem;
		}
		.jingbox .jingbai .caili .caititle{
			font-size: 1.6rem;
			padding: 1rem 0;
		}
		.jingbox .jingbai .caili .caitxt{
			font-size: 1.4rem;
			line-height: 1.8rem;
			margin-bottom: 2rem;
		}
		.jingbox .jingbai .caili .cailan{
			font-size: 1.4rem;
		}
		.paibox{
			justify-content: space-between;
		}
		.paibox .paili{
			margin: 0 0 1rem;
			width: 49%;
			height: 15rem;
		}
		.paibox .paili .paititle{
			font-size: 1.8rem;
		}
		.paibox .paili .paitxt{
			font-size: 1.4rem;
			line-height: 2rem;
		}
		.paibox .paili .libox .lileft .lilan{
			width: 7rem;
			height: 2.8rem;
			line-height: 2.8rem;
			font-size: 1.4rem;
		}
		.paibox .paili .libox .lileft .lizi{
			width: 7rem;
			height: 2.8rem;
			line-height: 2.8rem;
			font-size: 1.4rem;
		}
		.paibox .paili .libox .limoney{
			font-size: 1.4rem;
		}
	}
	
</style>